import { Box, Button, Divider, InputAdornment, TextField, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Pagination, Popover, MenuItem } from "@mui/material"
import { TEXT_TITLE_COLOR } from "../../constants/colors"
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { BrandModel } from "../../models/brand";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { numberFormat } from "../../utils/nunberFormat";
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';
import FormBrandView from "./form";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import ConfirmDialog from "../../components/ConfirmDialog";
import TableSearchNotFound from "../../components/tableSearchNotFound";
import useBrandController from "./controller/index";


const BrandView = () => {
    const controller = useBrandController()
    const { t } = useTranslation("global");
    // const TableHeader: string[] = [t("brand_page.No"), t("brand_page.Name Lao"), t("brand_page.Name Eng"), ""]
    const TableHeader: string[] = ["ລຳດັບ", "ຊື່ພາສາລາວ", "ຊື່ພາສາອັງກິດ", ""]

    return (
        <>
            {
                controller.openForm ?
                    <FormBrandView onClose={controller.handleCloseForm} selectedData={controller.selectedBrand} selectedValue={controller.setSelectedBrand} onFetchData={controller.handleFetchData} />
                    :
                    <Box>
                        {
                            controller.loadingData ?
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <LoadingAnimatedIcon />
                                </Box> :
                                <>
                                    <Box mb={3} sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                            <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                                                ການຈັດການພະລິດຕະພັນ
                                            </Typography>
                                            <TextField
                                                fullWidth
                                                sx={{ maxWidth: 250 }}
                                                placeholder={`ປ້ອນຊື່ພະລິດຕະພັນ...`}
                                                value={controller.searchValue}
                                                onChange={controller.handleSearchValue}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                size="small"
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
                                        <Button
                                            variant="contained"
                                            sx={{ textTransform: 'none', borderRadius: '10px', ml: 2, background: '#11A2F1' }}
                                            onClick={controller.handleOpenForm}
                                        >
                                            <AddIcon />
                                            &nbsp; ສ້າງພະລິດຕະພັນ
                                        </Button>
                                    </Box>
                                    <Box>
                                        <TableContainer>
                                            <Table>
                                                <TableHead sx={{ background: '#F4F6F8' }}>
                                                    <TableRow>
                                                        {
                                                            TableHeader.map((item, index) => <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>)
                                                        }
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        controller.rows?.map((rows: BrandModel, index: number) => {
                                                            const { id, nameEn, nameLa } = rows;
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                        {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                                                    </TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                        {nameEn}
                                                                    </TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                        {nameLa}
                                                                    </TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }} align="right">
                                                                        <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id)}>
                                                                            <MoreHorizIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                                {controller.isSearchNotFound && (
                                                    <TableSearchNotFound
                                                        searchValue={controller.searchValue}
                                                        colSpan={4}
                                                    />
                                                )}
                                            </Table>
                                        </TableContainer>
                                        <Divider sx={{ mt: 1, mb: 1 }} />
                                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                            <Pagination
                                                color="primary"
                                                count={controller.countPagination}
                                                page={controller.currentPage}
                                                onChange={controller.handleChangePage}
                                            />
                                        </Box>
                                    </Box>
                                    <Popover
                                        open={Boolean(controller.openMenu)}
                                        anchorEl={controller.openMenu}
                                        onClose={controller.handleCloseMenu}
                                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        PaperProps={{
                                            sx: {
                                                p: 1,
                                                width: 140,
                                                '& .MuiMenuItem-root': {
                                                    px: 1,
                                                    typography: 'body2',
                                                    borderRadius: 0.75,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={() => controller.handleOpenEditForm()}>
                                            <EditIcon />
                                            &nbsp;&nbsp; {t("Edit")}
                                        </MenuItem>
                                        <MenuItem onClick={() => controller.handleOpenDeleteForm()}>
                                            <DeleteIcon />
                                            &nbsp;&nbsp; {t("Delete")}
                                        </MenuItem>
                                    </Popover>
                                    <ConfirmDialog
                                        open={controller.openDeleteForm}
                                        title="Do you want to delete this Data ?"
                                        loading={controller.loadingButton}
                                        onCancel={controller.handleCloseDeleteForm}
                                        onConfirm={() => controller.handleDeleteBrand()}
                                    />
                                </>
                        }

                    </Box>
            }
        </>
    )
}
export default BrandView